var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "arrow-right.8734324e.png","uri@2x": __webpack_public_path__ + "arrow-right.890457f5.png","uri@3x": __webpack_public_path__ + "arrow-right.23d1ed69.png",
    width: 15,
    height: 26
});